import { useState } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import PeopleIcon from '@mui/icons-material/People';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  AppBar,
  Layout,
  Menu,
  MenuItemLink,
  UserMenu,
  Logout,
  usePermissions,
  type LayoutProps,
} from 'react-admin';

import { ChangePasswordDialog } from './ChangePasswordDialog';

function ChangePasswordMenuItem() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <MenuItem onClick={() => setOpen(true)}>
        <ListItemIcon>
          <LockIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Change password" />
      </MenuItem>
      <ChangePasswordDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}

function CustomUserMenu() {
  return (
    <UserMenu>
      <ChangePasswordMenuItem />
      <Logout />
    </UserMenu>
  );
}

function AdminAppBar() {
  return <AppBar userMenu={<CustomUserMenu />} />;
}

function AdminMenu() {
  const { permissions } = usePermissions();
  const canManageUsers = Array.isArray(permissions) && permissions.includes('user:manage');

  return (
    <Menu>
      <Menu.DashboardItem />
      <Menu.ResourceItem name="businesses" />
      <Menu.ResourceItem name="templates" />
      <Menu.ResourceItem name="categories" />
      <Menu.ResourceItem name="countries" />
      <Menu.ResourceItem name="states" />
      <Menu.ResourceItem name="cities" />
      {canManageUsers && (
        <MenuItemLink
          to="/users"
          primaryText="Users"
          leftIcon={<PeopleIcon />}
        />
      )}
      <Menu.ResourceItem name="leads" />
      <Menu.ResourceItem name="feedback" />
    </Menu>
  );
}

export function AdminLayout(props: LayoutProps) {
  return <Layout {...props} appBar={AdminAppBar} menu={AdminMenu} />;
}
